import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { paragraphMixins } from 'design-system/mixins/text';

export const MediumHeaderContainer = styled.div`
  ${paragraphMixins.md};
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: ${Spacing[6]};
`;

export const TableNullStateContainer = styled.div`
  text-align: center;
  margin: ${Spacing[2]};
`;
